export const openHubspotChat = () => {
  window.HubSpotConversations?.widget?.open();
};
